// now import local image ""./logos/skincare-1200.png" to use as logo_image:
import skincareLogo from "./logos/skincare.png";
import diceLogo from "./logos/dice.png";
import crisswordLogo from "./logos/crissword.png";
import crissgridLogo from "./logos/crissword-grid.png";
import fullcircleLogo from "./logos/circle.png";
import countupLogo from "./logos/countup.png";
import dailygoalsLogo from "./logos/dailygoals.png";
import todoLogo from "./logos/todo.png";
import seawardLogo from "./logos/seaward.png";
// import quizdatesLogo from "./logos/quizdates.png";
import travellistLogo from "./logos/travellist.png";
import cvLogo from "./logos/cv.png";
// import planetaryLogo from "./logos/planetary.png";
import foodfinderLogo from "./logos/foodfinder.png";
import shortestCircuitLogo from "./logos/shortest.png";
import mentoLogo from "./logos/mento.png";
import tileLogo from "./logos/tiles.png";
// import pcpLogo from "./logos/pcp.png";
import zeroLogo from "./logos/zero.png";
import flexitimerLogo from "./logos/flexitimer.png";
import nameappLogo from "./logos/nameapp.png";

export interface Project {
  title: string;
  subtitle?: string;
  description?: string;
  url: string;
  logo_url?: string;
  logo_full?: boolean;
  status?:
    | "in-progress"
    | "prototype"
    | "old"
    | "maintained"
    | "needs-updating";
  tags?: string[];
}

const projects: Project[] = [
  {
    title: "CrissWord",
    subtitle: "Daily Crossword-style Game",
    url: "https://crissword.com/",
    logo_url: crisswordLogo,
    logo_full: true,
    description: "Original word puzzle idea with new puzzles every day.",
    status: "maintained",
    tags: ["web", "game"],
  },
  {
    title: "CrissWord:GRID",
    subtitle: "New Crossword-style Game",
    url: "https://crissword.com/grid/",
    logo_url: crissgridLogo,
    logo_full: true,
    description: "New & original word puzzle idea.",
    status: "maintained",
    tags: ["web", "game"],
  },
  {
    title: "CrissWord: Full Circle",
    subtitle: "New Daily Word Game",
    url: "https://circle.crissword.com/",
    logo_url: fullcircleLogo,
    logo_full: true,
    description: "New & original word puzzle idea.",
    status: "maintained",
    tags: ["web", "game"],
  },
  {
    title: "Can't Stop, Won't Stop!",
    subtitle: "Multiplayer Dice Game (App)",
    url: "https://dice.mento.co.uk/",
    logo_url: diceLogo,
    logo_full: true,
    description:
      'After playing the original "Can\'t Stop" boardgame online during 2020, I wanted to improve on it, so I made my first online game. I still play it every day.',
    status: "maintained",
    tags: ["app", "web", "game"],
  },
  {
    title: "Skincare Routine",
    subtitle: "Organiser App",
    url: "https://skincareroutine.app/",
    logo_url: skincareLogo,
    description:
      "My biggest project so far, an app to help organise a skincare routine.",
    status: "maintained",
    tags: ["app"],
  },
  {
    title: "Shortest Circuit",
    subtitle: "Electric Path-Finding Puzzle Game",
    url: "https://shortest-circuit.mento.co.uk/",
    logo_url: shortestCircuitLogo,
    logo_full: true,
    description: "A fun shortest path-finding puzzle game.",
    status: "maintained",
    tags: ["web", "game"],
  },
  {
    title: "Daily Goals",
    subtitle: "Routine / Goal Tracker",
    url: "https://dailygoals.net/",
    logo_url: dailygoalsLogo,
    logo_full: true,
    description: "",
    status: "maintained",
    tags: ["web", "app"],
  },
  {
    title: "CountUp",
    subtitle: "Maths Game (App)",
    url: "https://mento.co.uk/countup/",
    logo_url: countupLogo,
    // logo_full: true,
    description:
      "My first mobile app. Inspired by the number challenge on the TV show, Countdown.",
    status: "maintained",
    tags: ["app", "web", "game"],
  },
  {
    title: "FlexiTimer",
    subtitle: "Fake Timer App",
    url: "https://mento.co.uk/flexitimer/",
    logo_url: flexitimerLogo,
    logo_full: true,
    description:
      "A simple timer app that allows for slowing down or speeding up the timer.",
    status: "maintained",
    tags: ["app"],
  },
  {
    title: "What's Their Name Again?",
    subtitle: "Name Remembering App",
    url: "https://mento.co.uk/whats-their-name-again/",
    logo_url: nameappLogo,
    logo_full: true,
    description:
      "A simple app that flashes up names to help you remember someone's name.",
    status: "maintained",
    tags: ["app"],
  },
  {
    title: "Zerø Scales",
    subtitle: "Smart scales with a difference.",
    url: "https://zeroscales.net/",
    logo_url: zeroLogo,
    logo_full: true,
    description:
      "Smart scales which can automatically calculate the net weight of the contents of your bowls.",
    status: "in-progress",
    tags: ["hardware"],
  },
  {
    title: "Todo List Priority Sorter",
    subtitle: "Task Manager",
    url: "https://mento.co.uk/todo-priority/",
    logo_url: todoLogo,
    description: "",
    status: "in-progress",
    tags: ["web"],
  },
  {
    title: "Food Finder",
    subtitle: "Map Tool",
    url: "https://mento.co.uk/food-finder/",
    logo_url: foodfinderLogo,
    logo_full: true,
    description: "Help find popular food spots nearby.",
    status: "in-progress",
    tags: ["web"],
  },
  {
    title: "The Travellist",
    subtitle: "Travel & Food Guides",
    url: "https://thetravellist.net/",
    logo_url: travellistLogo,
    logo_full: true,
    description:
      "A lot of it is out of date but the main bits are hopefully still useful.",
    status: "needs-updating",
  },
  {
    title: "Tile Game",
    subtitle: "Potential game idea",
    url: "https://chrisward.co.uk/code/tiles/",
    logo_url: tileLogo,
    logo_full: true,
    description: "An early prototype for a possible game.",
    status: "prototype",
    tags: ["web"],
  },
  // {
  //   title: "PCP Word Puzzle",
  //   subtitle: "Helper for The Guardian",
  //   url: "https://crissword.com/pcp/",
  //   logo_url: pcpLogo,
  //   logo_full: true,
  //   status: "prototype",
  //   description: "Based on a puzzle idea in The Guardian.",
  // },
  {
    title: "Mento Apps Ltd",
    subtitle: "My company",
    url: "https://mento.co.uk",
    logo_url: mentoLogo,
  },
  {
    title: "Seaward Photography",
    subtitle: "My photography",
    url: "https://photos.chrisward.co.uk/",
    logo_url: seawardLogo,
    logo_full: true,
    // description: "My photography.",
  },
  {
    title: "CV",
    subtitle: "My CV & Portfolio",
    url: "https://chrisward.co.uk/cv/",
    logo_url: cvLogo,
    logo_full: true,
  },
  // {
  //   title: "Quiz Dates",
  //   subtitle: "Simple date calculator",
  //   url: "https://mento.co.uk/quiz-dates/",
  //   logo_url: quizdatesLogo,
  //   logo_full: true,
  //   description:
  //     "A simple app to help calculate which date is closest to the correct answer.",
  // },
  // {
  //   title: "SPASM",
  //   subtitle: "Very old path-finding game",
  //   url: "https://chrisward.co.uk/code/spasm/",
  //   logo_url: spasmLogo,
  //   description: "A very old game I made that needs a lick of paint.",
  //   status: "old",
  // },
  // {
  //   title: "Planetary Health Diet",
  //   subtitle: "Very basic interactive guide",
  //   url: "https://mento.co.uk/planetary-health-diet/",
  //   logo_url: planetaryLogo,
  //   logo_full: true,
  //   status: "prototype",
  // },
];

export default projects;
